import React, { useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import "./Main.css";
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  useDisclosure,
  Button as ButtonChakra,
  Menu as MenuChakra,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import {
  FaBars,
  FaBitcoin,
  FaHouseUser,
  FaLink,
  FaStore,
  FaUser,
  FaDollarSign,
} from "react-icons/fa";
import { SettingFilled } from "@ant-design/icons";
import { FiLogOut } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { ExternalLinkIcon } from "lucide-react";
import { RESETAR_PASSWORD } from "../../../utils/links";

const Main = (props) => {
  const { children } = props;
  const { authInfo } = useContext(AuthContext);

  let navigate = useNavigate();

  const { dataUser } = authInfo;

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Flex width="100%" backgroundColor="#161920" flexDirection="column">
        <Flex padding="10px 20px">
          <FaBars onClick={onOpen} color="white" fontSize="24px" />
          <Drawer isOpen={isOpen} placement="left" onClose={onClose} size="xs">
            <DrawerOverlay />
            <DrawerContent backgroundColor="#161920" style={{ width: "220px" }}>
              <DrawerCloseButton color="white" />
              <DrawerBody
                paddingTop="50px"
                display="flex"
                flexDirection="column"
                gap="20px"
              >
                <Flex
                  width="100%"
                  gap="20px"
                  alignItems="center"
                  onClick={() => {
                    navigate(
                      dataUser.key === "ADMIN"
                        ? "/dashboard-clientes"
                        : "/dashboard-maquinas"
                    );
                    onClose();
                  }}
                  cursor="pointer"
                >
                  <FaHouseUser color="white" fontSize="20px" />
                  <span style={{ color: "white" }}>Visão Geral</span>
                </Flex>
                <Flex
                  width="100%"
                  gap="20px"
                  alignItems="center"
                  onClick={() => {
                    navigate("/modulos");
                    onClose();
                  }}
                  cursor="pointer"
                >
                  <SettingFilled
                    style={{ color: "white", fontSize: "20px" }}
                    color="white"
                  />
                  <span style={{ color: "white" }}>Módulos</span>
                </Flex>
                <Flex
                  width="100%"
                  gap="20px"
                  alignItems="center"
                  onClick={() => {
                    navigate("/vendas");
                    onClose();
                  }}
                  cursor="pointer"
                >
                  <FaBitcoin
                    style={{ color: "white", fontSize: "20px" }}
                    color="white"
                  />
                  <span style={{ color: "white" }}>Vendas</span>
                </Flex>
                <Flex
                  width="100%"
                  gap="20px"
                  alignItems="center"
                  onClick={() => {
                    navigate("/lojas");
                    onClose();
                  }}
                  cursor="pointer"
                >
                  <FaStore
                    style={{ color: "white", fontSize: "20px" }}
                    color="white"
                  />
                  <span style={{ color: "white" }}>Lojas</span>
                </Flex>
                <Flex
                  width="100%"
                  gap="20px"
                  alignItems="center"
                  onClick={() => {
                    navigate("/telemetria");
                    onClose();
                  }}
                  cursor="pointer"
                >
                  <FaLink
                    style={{ color: "white", fontSize: "20px" }}
                    color="white"
                  />
                  <span style={{ color: "white" }}>Telemetria</span>
                </Flex>
                {dataUser?.key === "ADMIN" && (
                  <>
                    <Flex
                      width="100%"
                      gap="20px"
                      alignItems="center"
                      onClick={() => {
                        navigate("/financeiro");
                        onClose();
                      }}
                      cursor="pointer"
                    >
                      <FaDollarSign
                        style={{ color: "white", fontSize: "20px" }}
                        color="white"
                      />
                      <span style={{ color: "white" }}>Financeiro</span>
                    </Flex>
                    <Flex
                      width="100%"
                      gap="20px"
                      alignItems="center"
                      onClick={() => {
                        navigate("/faturamento");
                        onClose();
                      }}
                      cursor="pointer"
                    >
                      <FaDollarSign
                        style={{ color: "white", fontSize: "20px" }}
                        color="white"
                      />
                      <span style={{ color: "white" }}>Faturamento</span>
                    </Flex>
                  </>
                )}

                {dataUser?.key !== "ADMIN" && (
                  <>
                    <Flex
                      width="100%"
                      gap="20px"
                      alignItems="center"
                      onClick={() => {
                        navigate("/cobrancas-cliente");
                        onClose();
                      }}
                      cursor="pointer"
                    >
                      <FaDollarSign
                        style={{ color: "white", fontSize: "20px" }}
                        color="white"
                      />
                      <span style={{ color: "white" }}>Cobranças</span>
                    </Flex>
                    <Flex
                      width="100%"
                      gap="20px"
                      alignItems="center"
                      /* onClick={() => {
                        navigate(links.RESETAR_PASSWORD);
                        onClose();
                      }} */
                      cursor="pointer"
                    >
                      <MenuChakra >{/* placement={'right-start'} */}
                        <MenuButton
                          as={ButtonChakra}
                          aria-label="Options"
                          /* icon={<FaUser />} */
                          variant="link"
                          style={{ display: "flex", width: "100%", alignItems: "center", border: "none", backgroundColor: "transparent" }}
                        ><div
                        style={{ display: "flex", width: "100%", alignItems: "center", gap: "20px" }}
                        ><FaUser
                        style={{ color: "white", fontSize: "20px" }}
                        color="white"
                      /><span style={{ color: "white" }}>Perfil</span></div></MenuButton>
                        <MenuList marginLeft={'50px'}>
                          <MenuItem icon={<ExternalLinkIcon />} onClick={() => {
                            navigate(RESETAR_PASSWORD);
                            onClose();
                          }}>
                            Resetar Senha
                          </MenuItem>
                        </MenuList>
                      </MenuChakra>
                    </Flex>
                  </>
                )}

                <Flex
                  width="100%"
                  gap="20px"
                  alignItems="center"
                  onClick={() => {
                    localStorage.clear();
                    window.location.reload();
                    navigate("/");
                  }}
                  cursor="pointer"
                  marginTop="50px"
                >
                  <FiLogOut
                    style={{ color: "white", fontSize: "20px" }}
                    color="white"
                  />
                  <span style={{ color: "white" }}>Sair</span>
                </Flex>
              </DrawerBody>
            </DrawerContent>
          </Drawer>
        </Flex>

        <div style={{ width: "100%", padding: "20px" }}>
          <div>{children}</div>
        </div>
      </Flex>
    </>
  );
};

export default Main;
